import { Box, Chip, IconButton, Typography, Tooltip } from "@mui/material";
import MaterialTable from "material-table";
import { useEffect, useState } from "react";
import { ConvertDate, ConvertTime, DateConvertInDbFormat } from "../../../../Base/helper/baseFunctions";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Popup from "../../../../Base/views/Popup";
import RegularizationActionPopUp from "./RegularizationActionPopUp";
import CommentIcon from '@mui/icons-material/Comment';
import BackdropMeepl from "../../../../Ancillary/AnimationComponents/BackdropMeepl";
import { GetApproverEmpRegularizationMappingAction, UpsertMyAttendanceRegularizationAction } from "../../../../../../store/Leave/Regularization/Action";
import RaiseRegularizationPopup from "../../MyTimeSheet/MyRegularization/RaiseRegularizationPopup";

const EmployeeRegularizationApproval = ({ value, openRegularizationDialog, dialogOpen, setDialogOpen, dialogMode }) => {
  const dispatch = useDispatch();
  const { isLoading, approver_emp_regularization_mapping } = useSelector(
    (state) => state?.LeaveReducer?.MyAttendanceRegularizationReducer,
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");

  const [openPopup, setOpenPopup] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);

  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const closeMode = (resetForm) => {
    setEditedRecord(null);
    setOpenPopup(false);
  };

  const getFilteredData = () => {
    if (value === "1") {
      return approver_emp_regularization_mapping?.filter((item) => item?.status === "Submitted");
    } else if (value === "2") {
      return approver_emp_regularization_mapping?.filter((item) => item?.status === "Approved" || item?.status === "Rejected");
    } 
  };

  useEffect(() => {
    dispatch(GetApproverEmpRegularizationMappingAction());
  }, [dispatch]);

  // raise employee regularization 
    const handleSubmitRowData = (rowData, actionType) => {
      if (actionType === "add") {
        const checkIn = getAttendanceDateTime(rowData?.check_in_time);
        const checkOut = getAttendanceDateTime(rowData?.check_out_time);
        
        const dateObj = new Date(checkIn.date);
        const month = (dateObj.getMonth() + 1).toString(); // "5"
        const year = dateObj.getFullYear().toString();  // "2026"

        dispatch(
          UpsertMyAttendanceRegularizationAction(
            {
              employee_fk: rowData?.employee_id?.employee_id,
              month: month,
              year: year,
              in_date: checkIn.date,
              out_date: checkOut.date,
              in_time: checkIn.time,
              out_time: checkOut.time,
              attendance_regularisation_pk: null,
              tab: "Team",
              status: "Submitted",
              actionType,
            },
            (res, err) => {
              if (res && !err) {
                dispatch(GetApproverEmpRegularizationMappingAction())
              }
            },
          ),
        );
      } else {
        console.log("Invalid action type:", actionType);
      }
    };


  const tableTitle = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        {value === "2" ? "Processed Attendance Regularization Requests" : "Attendance Regularization Requests Requiring Action"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {value === "2" ? "View attendance regularization requests that have been approved or rejected." : "Review and approve or reject attendance regularization requests submitted"}
      </Typography>
    </Box>
  );

  return (
    <Box>
      <Box
        sx={{
          borderRadius: "10px",
          maxHeight: "calc(100vh - 155px)",
          overflowY: "auto",
        }}
      >
        <MaterialTable
          columns={[
            { title: "Employee", 
              field: "emp_name",
              headerStyle: {
                maxWidth: 150,
                minWidth: 150,
                padding: "5px 0px 5px 10px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 150,
                minWidth: 150,
                textAlign: "start",
                padding: "5px 0px 5px 13px",
              },
             },
            {
              title: "Date",
              field: "in_date",
              headerStyle: {
                maxWidth: 150,
                minWidth: 150,
                padding: "5px 0px 5px 5px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 150,
                minWidth: 150,
                textAlign: "start",
                padding: "5px 0px 5px 5px",
              },
              render: (data) => ConvertDate(data?.in_date),
            },
            {
              field: "in_time",
              title: "Check-In Time",
              headerStyle: {
                maxWidth: 175,
                minWidth: 175,
                padding: "5px 0px 5px 5px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 175,
                minWidth: 175,
                textAlign: "start",
                padding: "5px 0px 5px 5px",
              },
              render: (data) => ConvertTime(data?.in_time, true)
            },
            {
              field: "out_time",
              title: "Check-Out Time",
              headerStyle: {
                maxWidth: 190,
                minWidth: 190,
                padding: "5px 0px 5px 25px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 190,
                minWidth: 190,
                textAlign: "start",
                padding: "5px 0px 5px 25px",
              },
              render: (data) => ConvertTime(data?.out_time, true)
            },
            {
              title: "Status",
              headerStyle: {
                maxWidth: 130,
                minWidth: 130,
                padding: "5px 0px 5px 10px",
                textAlign: "end",
              },
              cellStyle: {
                maxWidth: 130,
                minWidth: 130,
                textAlign: "end",
                padding: "5px 0px 5px 0px",
              },
              field: "status",
              render: (rowData) => {
                const { bg, text } = getStatusColor(rowData?.status);
                return (
                    <Chip
                      label={rowData?.status}
                      style={{
                        backgroundColor: bg,
                        color: text,
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                );
              },
              hidden: value === "1",
            },
            {
              field: "comments",
              title: "Approver Comment",
              headerStyle: {
                maxWidth: 110,
                minWidth: 110,
                padding: "5px 0px 5px 5px",
                textAlign: "center",
              },
              cellStyle: {
                maxWidth: 110,
                minWidth: 110,
                textAlign: "center",
                padding: "5px 0px 5px 5px",
              },
              sorting: false,
              hidden: value === "1",
              render: (rowData) => {
                return (
                  <Box width={"90%"}>
                    <Tooltip title={rowData?.comments || ""} arrow>
                      <CommentIcon sx={{
                        fontSize: "20px",
                        color: rowData?.comments ? "#637381" : "#95a0ab",
                        cursor: rowData?.comments ? "pointer" : "default",
                      }} />
                    </Tooltip>
                  </Box>
                );
              },
            },
          ]}
          data={getFilteredData()}
          isLoading={isLoading}
          options={{
            maxBodyHeight: "calc(100vh - 282px)",
            minBodyHeight: "calc(100vh - 282px)",
            rowStyle: {
              fontSize: "13px",
              height: "35px",
            },
            cellStyle: {
              padding: "5px 0px 5px 13px",
            },
            headerStyle: {
              padding: "5px 27px 5px 10px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "Employees",
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            grouping: false,
            columnsButton: false,
          }}
          actions={
            value === "1" ? [
              {
                icon: () => (
                  <IconButton sx={{ padding: "0px" }}>
                    <CheckCircleIcon color= {!ExternalUserCoreHr ? "primary" : "disabled"} />
                  </IconButton>
                ),
                tooltip: ExternalUserCoreHr ? "Action is disabled." : "Approve/Reject",
                disabled: ExternalUserCoreHr,
                onClick: (_event, rowData) => {
                  handleEdit(rowData);
                },
              },
            ] : []
          }
          components={{
            Overlay: () => null,
            OverlayLoading: () => <BackdropMeepl open={true} dark={false} />,
          }}
          title={tableTitle}
        />
        <Popup
          title={"Approve/Reject"}
          openPopup={openPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="xs"
        >
          <RegularizationActionPopUp
            editedRecord={editedRecord}
            closeMode={closeMode}
          />
        </Popup>

        <Popup
          title={"Add Attendance Regularization"}
          openPopup={dialogOpen}
          setOpenPopup={setDialogOpen}
        >
          <RaiseRegularizationPopup
            editedRecord={null}
            setOpenPopup={setDialogOpen}
            onSubmit={(data) => {
              handleSubmitRowData(data, dialogMode);
            }}
            addMode={false}
            startOfMonth={null}
            endOfMonth={null}
            team={true}
          />
        </Popup>
      </Box>
    </Box>
  );
};

const getLocalISOString = (date) => {
  if (!date) return null;

  const offsetInMinutes = date?.getTimezoneOffset();
  const localTime = new Date(date.getTime() - offsetInMinutes * 60000);

  return localTime.toISOString().slice(0, -1);
};

const getAttendanceDateTime = (value) => {
  if (!value) {
    return {
      date: null,
      time: null,
    };
  }
  // Existing record from DB
  if (typeof value === "string") {
    return {
      date: value.split("T")[0],
      time: value,
    };
  }
  // User modified value in DateTimePicker
  if (value instanceof Date) {
    return {
      date: DateConvertInDbFormat(value),
      time: getLocalISOString(value),
    };
  }
  return {
    date: null,
    time: null,
  };
};
export default EmployeeRegularizationApproval;

const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
    case "Action Needed":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
    case "Self Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" }; // blue
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
